const elearningEventsSection = $('#events-section');
const elearningEventsCards = elearningEventsSection.find('.event-card');
const elearningEventsDropdown = elearningEventsSection.find('.events-tags-parent');
const elearningEventsTags = elearningEventsDropdown.find('.events-search-tag');
let activeTag = undefined;

const sortEventsCards = (currentTag) => {
    const tagValue = currentTag.attr('data-tag');
    if(tagValue == 'All'){
        gsap.set(elearningEventsCards, {display: 'flex'});
    } else {
        gsap.set(elearningEventsCards, {
            display: (index) => elearningEventsCards.eq(index).attr('data-tag') == tagValue ? 'flex' : 'none',
        })
    }
}

const changeEventsActiveTag = (currentTag) => {
    if(activeTag){
        activeTag.removeClass('active');
    }
    currentTag.addClass('active');
    sortEventsCards(currentTag);
    activeTag = currentTag;
}

const addEventsTagControl = () => {
    elearningEventsTags.on('click', function(){
        changeEventsActiveTag($(this));
    });
}

const addelearningEventsAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };
  const eventBtn = elearningEventsSection.find('.button-parent');

  const eventTopperTL = gsap.timeline({ paused: true });
  const eventTL = gsap.timeline({ paused: true });

  eventTopperTL.add(
    animateSectionTopperIn({
      sectionParent: elearningEventsSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  eventTopperTL.add(elementInAnimationYWOpacity(elearningEventsDropdown, '100%', 0, 1, 1, 1, 0).play(), 0);
  eventTL.add(elementInAnimationYWOpacity(elearningEventsCards, '300%', 0, 1, 1, 0.8, 0.2, 0.1, 'start', 'pageInEasing', 'pageInEasing').play(), 0);
  addBtnAnimation(eventBtn, 50, true);

  return [eventTopperTL, eventTL];
}

const initelearningEvents = () => {
  changeEventsActiveTag(elearningEventsTags.eq(0));
  addEventsTagControl();
  if(isDesktop()){
    const [eventTopperTL, eventTL] = addelearningEventsAnimation();
    ScrollTrigger.create({
      trigger: elearningEventsSection,
      start: 'top top+=110%',
      end: 'bottom bottom',
      once: true,
      onUpdate: (self) => {
        eventTopperTL.progress(self.progress);
      },
    });

    ScrollTrigger.create({
      trigger: elearningEventsSection,
      start: 'top+=30% bottom',
      end: 'top top',
      once: true,
      onEnter: () => {
        eventTL.play();
      },
    });
  }
}

addSectionObserver(elearningEventsSection, initelearningEvents);